import loginDialogReducer from './loginDialogReducer';

export default loginDialogReducer;